import api from './api';

export interface DashboardStats {
  total_utilizadores: number;
  total_entidades: number;
  transacoes_mes: number;
  receita_mes: number;
  utilizadores_ativos: number;
  ticket_medio: number;
  taxa_sucesso: number;
  transacoes_trend: number;
  receita_trend: number;
  utilizadores_trend: number;
  ticket_trend: number;
  novos_utilizadores_mes: number;
  novos_utilizadores_trend: number;
}

export interface RevenueTimelinePoint {
  date: string;
  revenue: number;
  transactions: number;
}

export interface ServiceBreakdown {
  name: string;
  code: string;
  transactions: number;
  revenue: number;
  percentage: number;
}

export interface StatusBreakdown {
  status: string;
  count: number;
  amount: number;
  percentage: number;
}

export interface UserGrowth {
  month: string;
  utilizadores: number;
}

export interface PaymentVolume {
  day: string;
  volume: number;
}

export interface TopEntity {
  name: string;
  revenue: number;
  transactions: number;
}

export interface HourlyPatternPoint {
  hour: string;
  count: number;
}

export interface DeviceBreakdown {
  device: string;
  count: number;
  revenue: number;
  percentage: number;
}

export interface DeviceTimelinePoint {
  date: string;
  dateLabel: string;
  web: number;
  mobile: number;
}

export interface AdminDashboardData {
  stats: DashboardStats;
  revenueTimeline: RevenueTimelinePoint[];
  servicesBreakdown: ServiceBreakdown[];
  statusBreakdown: StatusBreakdown[];
  topEntities: TopEntity[];
  userGrowth: UserGrowth[];
  hourlyPattern: HourlyPatternPoint[];
  paymentVolume: PaymentVolume[];
  deviceBreakdown: DeviceBreakdown[];
  deviceTimeline: DeviceTimelinePoint[];
}

class DashboardService {
  /**
   * Get admin dashboard data
   */
  async getAdminDashboard(): Promise<AdminDashboardData> {
    try {
      const response = await api.get('/admin/dashboard/admin');
      return response.data.data;
    } catch (error) {
      console.error('Get admin dashboard error:', error);
      throw error;
    }
  }

  /**
   * Get client dashboard data
   */
  async getClientDashboard(userId: string) {
    try {
      const response = await api.get(`/admin/dashboard/client/${userId}`);
      return response.data.data;
    } catch (error) {
      console.error('Get client dashboard error:', error);
      throw error;
    }
  }

  /**
   * Get entity dashboard data
   */
  async getEntityDashboard(entityId: string) {
    try {
      const response = await api.get(`/admin/dashboard/entity/${entityId}`);
      return response.data.data;
    } catch (error) {
      console.error('Get entity dashboard error:', error);
      throw error;
    }
  }
}

export default new DashboardService();
